module.exports = new __parcel__URL__("yellow-submarine.12d44e45.jpg").toString();